import { computed, defineComponent, onMounted, onUnmounted, onUpdated, ref } from 'vue';
import { Popover } from 'bootstrap';
import { useDateFormat } from '@/composables/dateFormat';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { AnnouncementAction, AnnouncementGetter } from '@/store/announcement/announcement.module';
import { Announcement } from '@/store/announcement/announcement.model';
import LoadingComponent from '@/components/loading/Loading.vue';

export default defineComponent({
  name: 'AnnouncementTableComponent',
  components: {
    LoadingComponent,
  },
  setup: () => {
    const dateFormat = useDateFormat();
    const router = useRouter();
    const store = useStore();
    const announcements = computed<Announcement[]>(() => store.getters[AnnouncementGetter.ALL]);
    const datatable = ref<HTMLTableElement>();
    const dtInstance = ref();
    const popoverList = ref<Popover[]>([]);
    const isLoading = computed(() => store.getters[AnnouncementGetter.STATUS] === 'init' || store.getters[AnnouncementGetter.STATUS] === 'loading');

    onMounted(() => {
      store.dispatch(AnnouncementAction.FETCH)
        .then(() => updateDataTable());
    });

    onUpdated(() => updateDataTable());

    onUnmounted(() => {
      dtInstance.value?.destroy();
    });

    const selectedClick = (id: number) => {
      Promise.resolve(popoverList.value.map(element => element.hide()))
        .then(() => router.push(`/announcement/${id}`));
    };

    const toggleClick = (id: number) => {
      const announcement = announcements.value.find(m => m.id == id);
      store.dispatch(AnnouncementAction.UPDATE, {
        id: id,
        title: announcement?.title,
        content: announcement?.content,
        pined: !announcement?.pined,
      });
    };

    const updateDataTable = () => {
      Promise.resolve(initialPopover())
        .then(() => initialDataTable());
    };

    const initialDataTable = () => {
      Promise.resolve(dtInstance.value?.destroy())
        .then(() => {
          const dt = datatable.value as HTMLTableElement;
          if (!$.fn.dataTable.isDataTable(dt)) {
            dtInstance.value = $(dt).DataTable({
              language: {
                emptyTable: 'ไม่พบข้อมูล',
                info: 'แสดง _START_ ถึง _END_ จากจำนวนทั้งหมด _TOTAL_',
                infoEmpty: 'แสดง 0 ถึง 0 จากจำนวนทั้งหมด 0',
                infoFiltered: '(ค้นหาจากจำนวนทั้งหมด _MAX_)',
                lengthMenu: 'แสดงข้อมูล _MENU_',
                paginate: {
                  next: 'ถัดไป',
                  previous: 'ก่อนหน้า',
                  first: 'First',
                  last: 'Last'
                },
                search: 'ค้นหา:',
                zeroRecords: 'ไม่พบข้อมูลที่ค้นหา',
              }
            });
          }
        });
    };

    const initialPopover = () => {
      const popoverTriggerList = computed<HTMLElement[]>(() => [].slice.call(document.querySelectorAll('[data-bs-toggle="popover-announcement"]')) as HTMLElement[]);
      popoverList.value.map(element => element.hide());
      popoverList.value = popoverTriggerList.value?.map(element => new Popover(element, { trigger: 'hover', placement: 'right' }));
    };

    const thaiDate = (date: Date) =>
      dateFormat.toThaiDate(date, 'short');

    return {
      isLoading,
      announcements,
      datatable,
      toggleClick,
      selectedClick,
      thaiDate,
    };
  },
});
